module.exports = __webpack_public_path__ + "static/media/Korg-N1R-High-Q.03181901.wav";